"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidatedInput = exports.Input = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ValidationHOC = require("./ValidationHOC");

var _ValidationHOC2 = _interopRequireDefault(_ValidationHOC);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Input = function Input(props) {
  return _react2.default.createElement("input", {
    type: props.type,
    onChange: props.onChange,
    name: props.name,
    defaultValue: props.value,
    placeholder: props.placeholder
  });
};

Input.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  name: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.string,
  placeholder: _propTypes2.default.string
};
Input.defaultProps = {
  type: "text",
  placeholder: ""
};
var ValidatedInput = (0, _ValidationHOC2.default)(Input);
exports.Input = Input;
exports.ValidatedInput = ValidatedInput;